export const adminOperationsMessages = {
  kk: {
    saleMode: {
      title: 'Касса режимі',
      subtitle: 'Кассирлер сатуды қалай рәсімдейді',
      current: 'Қазір',
      loading: 'Жүктелуде...',
      active: 'Белсенді',
      howItWorks: 'Бұл қалай жұмыс істейді',
      note: '«Жылдам сату» режимінде қойма есебі жүргізілмейді — кассир тек сома мен төлем түрін енгізеді. Бонустар мен қарыз әдеттегідей жұмыс істейді. Режимді кез келген уақытта өзгертуге болады.',
      catalog: {
        label: 'Тауарлар бойынша',
        description: 'Кассир тауарларды таңдайды, қалдықтар қоймадан есептен шығарылады',
        points: ['Тауарлар және қоймадағы қалдықтар', 'Тауар позицияларына жеңілдіктер', 'Тауарлар бойынша аналитика'],
      },
      quick: {
        label: 'Жылдам сату',
        description: 'Тек сома мен төлем түрі. Қойма есебі жүргізілмейді, бонус есептеуге болады',
        points: ['Тек сома мен төлем түрі', 'Қойма есебі жүргізілмейді', 'Бонус пен қарыз қолжетімді'],
      },
      updated: 'Режим жаңартылды',
    },
    cashiers: {
      title: 'Кассирлер',
      subtitle: 'Касса пайдаланушылары және олардың құқықтары',
      add: 'Кассир қосу',
      edit: 'Өзгерту',
      delete: 'Жою',
      unnamed: 'Аты жоқ',
      administrator: 'Админ',
      cashier: 'Кассир',
      productsAndStock: 'Тауарлар және қойма',
      emptyTitle: 'Әзірге тек сіз',
      emptyText: 'Кассирлерді қосыңыз — олар кассаға өз құпиясөзімен кіре алады',
      editTitle: 'Кассирді өңдеу',
      addTitle: 'Кассир қосу',
      name: 'Аты',
      namePlaceholder: 'Мысалы: Айгүл',
      email: 'Кіруге арналған e-mail',
      password: 'Құпиясөз',
      newPassword: 'Жаңа құпиясөз (бос қалдырсаңыз — өзгермейді)',
      permission: 'Құқықтар: тауарларды қосу және өзгерту, қойманы толықтыру',
      cancel: 'Болдырмау',
      save: 'Сақтау',
      deleteTitle: 'Кассирді жою керек пе?',
      deleteText: '«{name}» енді кассаға кіре алмайды. Оның чектері тарихта қалады.',
      deleted: 'Кассир жойылды',
      deleteFailed: 'Кассирді жою мүмкін болмады',
      enterName: 'Атын көрсетіңіз',
      enterEmail: 'E-mail көрсетіңіз',
      passwordMin: 'Құпиясөз кемінде 6 таңбадан тұруы керек',
      saved: 'Сақталды',
    },
    sales: {
      title: 'Сатылымдар',
      subtitle: 'Чектер мен тапсырыс құрамы тарихы',
      searchPlaceholder: 'Іздеу: чек №, тауар, сома, төлем...',
      total: 'Барлығы',
      receipt: 'Чек №{id}',
      discount: 'Жеңілдік −{amount}',
      quick: 'Жылдам',
      product: 'Тауар',
      quantity: 'Саны',
      stock: 'Қалдық',
      soldUnits: 'Сатылды',
      addedUnits: 'Қосылды',
      soldTogether: 'Бірге',
      unitPcs: 'шт',
      unitKg: 'кг',
      unitL: 'л',
      price: 'Бағасы',
      amount: 'Сома',
      quickSaleEmpty: 'Жылдам сату — тауарлар бойынша бөлінбейді',
      receiptEmpty: 'Чек құрамы бос',
      nothingFound: 'Ештеңе табылмады',
      noSales: 'Әзірге сатылымдар жоқ',
      tryAnother: 'Басқа сұрауды байқап көріңіз',
      receiptsAppear: 'Кассада төлем жасалғаннан кейін чектер осы жерде пайда болады',
      productDeleted: 'Тауар жойылды',
      mixed: 'Аралас',
      discountDefault: 'Жеңілдік',
      allPayments: 'Барлық төлемдер',
      paymentFilter: 'Төлем',
      allProducts: 'Барлық тауарлар',
      selectedProduct: 'Тауар',
      cost: 'Өзіндік құны',
      retailPrice: 'Бөлшек бағасы',
      stockNow: 'Қазіргі қалдық',
      historyQuantity: 'Бастапқы салмақ',
      logDate: 'Күні',
      logType: 'Түрі',
      logIn: 'Кіріс',
      logOut: 'Сатылым',
      logWaste: 'Отход',
      logsEmpty: 'Осы кезеңде product_logs жазбалары жоқ',
      allPeriod: 'Барлық кезең',
      allSuppliers: 'Барлық жеткізушілер',
      allModes: 'Барлық режимдер',
      catalogMode: 'Тауарлар бойынша',
      withDiscount: 'Жеңілдікпен',
      dateFrom: 'Бастап',
      dateTo: 'Дейін',
      selectDate: 'Күнді таңдау',
      selectDateDone: 'Таңдау',
      clearDates: 'Күндерді тазалау',
      revenue: 'Түсім',
      receipts: 'Чектер',
      averageReceipt: 'Орташа чек',
      discountsTotal: 'Жеңілдіктер',
      supplierDue: 'Жеткізушіге есеп',
      supplierDueHint: 'Себес × бастапқы салмақ (бірге сатылатынсыз)',
      expensesTotal: 'Шығындар',
      wastesTotal: 'Отходтар',
      profit: 'Пайда',
      profitFormulaTitle: 'Пайданы есептеу',
      profitFormulaHint: 'Жоғарыдағы сандарды басыңыз — шығынды есептен алып тастау немесе қайтару',
      profitPartOn: 'Есептеуде · басып өшіру',
      profitPartOff: 'Өшірулі · басып қосу',
      refunded: 'Қайтарылды',
      refund: 'Қайтару',
      refundReason: 'Қайтару себебі',
      refundReasonRequired: 'Қайтару себебін көрсетіңіз',
      refundedMessage: 'Чек қайтарылды',
      print: 'Басып шығару',
      close: 'Жабу',
      openShift: 'Ауысымды ашу',
      closeShift: 'Ауысымды жабу',
      openingCash: 'Кассадағы бастапқы қолма-қол сома',
      actualCash: 'Кассадағы нақты қолма-қол сома',
    },
    analytics: {
      title: 'Аналитика',
      subtitle: 'Сатылымдар бойынша түсім, пайда және өсу нүктелері',
      overview: 'Шолу',
      week: 'Апта',
      year: 'Жыл',
      loading: 'Аналитика жүктелуде...',
      todayRevenue: 'Бүгін · түсім',
      todayReceipts: 'Бүгін · чектер',
      days30Profit: '30 күн · пайда',
      averageReceipt: 'Орташа чек',
      vsYesterday: 'кешегімен салыстырғанда',
      margin: 'маржа {value}%',
      receiptsForDays: '{count} чек · 30 күнде',
      bestDay: 'Ең жақсы күн',
      salesPeak: 'Сату шыңы',
      around: 'шамамен {time} —',
      salesHit: 'Сату хиті',
      units: 'дана',
      weekToWeek: 'Апта сайын',
      revenue: 'түсім',
      revenue14Days: '14 күндегі түсім',
      revenueForDays: '{amount} · 30 күнде',
      paymentTypes: 'Төлем түрлері',
      days30: '30 күн',
      noPayments: 'Әзірге төлемдер жоқ',
      topProducts: 'Үздік 10 тауар',
      byQuantity: 'Саны бойынша',
      byRevenue: 'Түсім бойынша',
      soldShort: 'сат.',
      profit: 'пайда',
      noSalesPeriod: 'Кезеңде сатылымдар жоқ',
      hourlyActivity: 'Сағат бойынша белсенділік',
      cashierRevenue: 'Кассирлер бойынша түсім',
      today: 'бүгін',
      receiptsToday: '{count} чек',
      todayZero: 'бүгін — 0',
      lowStock: 'Төмен қалдық',
      units5: '≤ 5 бірлік',
      ordersWeek: 'Аптадағы тапсырыстар',
      ordersYear: 'Жылдағы тапсырыстар',
      profitLabel: 'Пайда',
      sold: 'Сатылды: {count}',
      revenueLabel: 'Түсім: {amount}',
      profitLabelValue: 'Пайда: {amount}',
      noWeekData: 'Осы аптаға дерек жоқ',
      noYearData: 'Осы жылға дерек жоқ',
      total: 'Барлығы',
      receipts: 'Чектер',
      receiptTooltip: '{value} чек',
    },
    bonuses: {
      title: 'Бонустар',
      subtitle: 'Клиенттер және жинақталған бонустар',
      searchPlaceholder: 'Аты-жөні, телефон немесе карта №',
      accrualRate: 'Есептеу пайызы',
      accrualText: 'Төлем жасағанда клиентке чек сомасының {value}% есептеледі',
      percent: 'Пайыз, %',
      saving: 'Сақталуда...',
      save: 'Сақтау',
      clients: 'Клиенттер',
      totalBonuses: 'Барлық бонустар',
      now: 'Қазір',
      loading: 'Жүктелуде...',
      unnamed: 'Аты жоқ',
      card: 'карта',
      bonus: 'Бонус',
      nothingFound: 'Ештеңе табылмады',
      noClients: 'Әзірге бонус-клиенттер жоқ',
      tryAnother: 'Басқа сұрауды байқап көріңіз',
      clientsAppear: 'Кассада бонус есептелгеннен кейін клиенттер осы жерде пайда болады',
      percentRange: '0-ден 100-ге дейінгі пайызды көрсетіңіз',
      percentSaved: 'Пайыз сақталды',
      mode: 'Бонус түрі',
      modePercent: 'Чек пайызынан',
      modeNPurchase: 'N-ші сатып алу',
      nPurchaseTitle: 'N-ші сатып алуға бонус',
      nPurchaseText: 'Әр {count}-ші сатып алудан кейін клиентке {value} ₸ бонус беріледі',
      purchasesCount: 'Сатып алулар саны, N',
      rewardAmount: 'Бонус сомасы, ₸',
      nPurchaseRange: 'Сатып алулар санын және бонус сомасын көрсетіңіз',
      settingsSaved: 'Бонус баптаулары сақталды',
    },
    loans: {
      title: 'Қарыздар',
      subtitle: 'Кассадан клиенттердің қарыздары · қайтару және мерзімін бақылау',
      searchPlaceholder: 'Аты, телефон, сома...',
      open: 'Ашық',
      overdue: 'Мерзімі өткен',
      paid: 'Өтелген',
      partial: 'Ішінара өтелген',
      cancelled: 'Бас тартылған',
      all: 'Барлығы',
      openPlural: 'Ашықтар',
      overduePlural: 'Мерзімі өткендер',
      paidPlural: 'Өтелгендер',
      cancelledPlural: 'Бас тартылғандар',
      unnamed: 'Аты жоқ',
      amount: 'Сома',
      paidAmount: 'Төленді',
      remainingAmount: 'Қалды',
      dueDate: 'Қайтару мерзімі',
      receipt: 'Чек',
      created: 'Құрылды',
      pay: 'Өтеу',
      cancelLoan: 'Қарызды болдырмау',
      history: 'Тарихы',
      nothingFound: 'Ештеңе табылмады',
      noLoans: 'Әзірге қарыздар жоқ',
      emptyText: 'Қарызды осында қолмен қосыңыз немесе кассада «Қарыз» төлемін таңдаңыз',
      add: 'Қарыз қосу',
      addTitle: 'Қарызды рәсімдеу',
      addText: 'Қарыз бірден тізімге қосылады — чек жасалмайды',
      addSave: 'Сақтау',
      debtorName: 'Борышкердің аты',
      debtorNamePlaceholder: 'Клиенттің аты кім',
      debtorPhone: 'Телефон',
      whatsappPhone: 'WhatsApp нөмірі',
      debtorPhonePlaceholder: '8 (XXX) XXX-XX-XX',
      extraPhone: 'Қосымша нөмір',
      addPhone: 'Нөмір қосу',
      removePhone: 'Нөмірді өшіру',
      openWhatsapp: 'WhatsApp-та ашу',
      extraPhoneInvalid: 'Қосымша нөмір 11 цифр болуы керек',
      note: 'Ескертпе',
      notePlaceholder: 'Қосымша ақпарат (міндетті емес)',
      returnDate: 'Қайтару күні',
      selectDate: 'Күнді таңдау',
      selectDateDone: 'Таңдау',
      totalDebt: 'Қарыздың жалпы сомасы',
      returnBy: 'Қайтару мерзімі',
      nameRequired: 'Атын көрсетіңіз',
      phoneRequired: 'WhatsApp нөмірін көрсетіңіз (11 цифр)',
      amountRequired: 'Қарыз сомасын көрсетіңіз',
      dueDateRequired: 'Қайтару мерзімін көрсетіңіз',
      createdMessage: 'Қарыз қосылды',
      payTitle: 'Қарызды өтеу',
      payText: '«{name}» қарызын толық немесе ішінара өтеуге болады. Қалған сома: {amount}.',
      repaymentAmount: 'Төлем сомасы',
      repaymentAmountRequired: 'Қайтару сомасын көрсетіңіз',
      repaymentAmountTooHigh: 'Төлем сомасы қалған қарыздан аспауы керек',
      partialRepaid: 'Ішінара төлем сақталды',
      payPartial: 'Ішінара өтеу',
      payFull: 'Толық өтеу',
      payPartialHint: 'Қарыз ішінара өтеледі, қалдығы қалады',
      payFullHint: 'Қарыз толық жабылады',
      payAmountHint: 'Кез келген соманы енгізіңіз — қалғаннан аспасын',
      payFullPreset: 'Барлығы',
      afterPayRemaining: 'Төлемнен кейін қалады: {amount}',
      historyAmount: 'Сома: {amount}',
      partialPlural: 'Ішінара',
      dateFrom: 'Бастап',
      dateTo: 'Дейін',
      clearDates: 'Күндерді тазалау',
      cancel: 'Болдырмау',
      cancelTitle: 'Қарызды болдырмау керек пе?',
      cancelText: 'Жазба жойылмайды — ол «Бас тартылған» мәртебесімен тарихта қалады.',
      cancelReason: 'Болдырмау себебі',
      cancelReasonPlaceholder: 'Мысалы: чек қате рәсімделді',
      cancelReasonRequired: 'Болдырмау себебін көрсетіңіз',
      cancelledAt: 'Болдырмау уақыты',
      cancelledMessage: 'Қарыз болдырмады',
      historyTitle: 'Қарыз тарихы',
      historyEmpty: 'Әрекеттер әлі жоқ',
      actionCreated: 'Қарыз жасалды',
      actionPaid: 'Қарыз өтелді',
      actionRepayment: 'Ішінара төлем',
      actionCancelled: 'Қарыз болдырмады',
      repaid: 'Қарыз өтелді',
    },
  },
  ru: {
    saleMode: {
      title: 'Режим кассы', subtitle: 'Как кассиры оформляют продажи', current: 'Сейчас', loading: 'Загрузка...', active: 'Активен', howItWorks: 'Как это работает',
      note: 'В режиме «Быстрая продажа» склад не списывается — кассир вводит только сумму и тип оплаты. Бонусы и долги (қарыз) работают как обычно. Сменить режим можно в любой момент.',
      catalog: { label: 'По товарам', description: 'Кассир выбирает товары, остатки списываются со склада', points: ['Товары и остатки на складе', 'Скидки по позициям', 'Аналитика по товарам'] },
      quick: { label: 'Быстрая продажа', description: 'Только сумма и тип оплаты. Склад не трогается, бонус можно начислять', points: ['Только сумма и тип оплаты', 'Склад не трогается', 'Бонус и қарыз доступны'] },
      updated: 'Режим обновлён',
    },
    cashiers: {
      title: 'Кассиры', subtitle: 'Пользователи кассы и их права', add: 'Добавить кассира', edit: 'Изменить', delete: 'Удалить', unnamed: 'Без имени', administrator: 'Администратор', cashier: 'Кассир', productsAndStock: 'Товары и склад',
      emptyTitle: 'Пока только вы', emptyText: 'Добавьте кассиров — они смогут входить на кассу под своим паролем', editTitle: 'Редактировать кассира', addTitle: 'Добавить кассира', name: 'Имя', namePlaceholder: 'Например: Айгуль', email: 'E-mail для входа', password: 'Пароль', newPassword: 'Новый пароль (пусто — не менять)', permission: 'Права: добавление и изменение товаров, пополнение склада', cancel: 'Отмена', save: 'Сохранить', deleteTitle: 'Удалить кассира?', deleteText: '«{name}» больше не сможет войти на кассу. Его чеки останутся в истории.', deleted: 'Кассир удалён', deleteFailed: 'Не удалось удалить кассира', enterName: 'Укажите имя', enterEmail: 'Укажите e-mail', passwordMin: 'Пароль минимум 6 символов', saved: 'Сохранено',
    },
    sales: {
      title: 'Продажи', subtitle: 'История чеков и состава заказов', searchPlaceholder: 'Поиск: № чека, товар, сумма, оплата...', total: 'Всего', receipt: 'Чек №{id}', discount: 'Скидка −{amount}', quick: 'Быстрая', product: 'Товар', quantity: 'Кол-во', stock: 'Остаток', soldUnits: 'Продано', addedUnits: 'Добавлено', soldTogether: 'Вместе', unitPcs: 'шт', unitKg: 'кг', unitL: 'л', price: 'Цена', amount: 'Сумма', quickSaleEmpty: 'Быстрая продажа — без разбивки по товарам', receiptEmpty: 'Состав чека пуст', nothingFound: 'Ничего не найдено', noSales: 'Продаж пока нет', tryAnother: 'Попробуйте другой запрос', receiptsAppear: 'Чеки появятся здесь после оплаты на кассе', productDeleted: 'Товар удалён', mixed: 'Смешанная', discountDefault: 'Скидка', allPayments: 'Все оплаты', paymentFilter: 'Оплата', allProducts: 'Все товары', selectedProduct: 'Товар', cost: 'Себестоимость', retailPrice: 'Розничная цена', stockNow: 'Текущий остаток', historyQuantity: 'Изначальный вес', logDate: 'Дата', logType: 'Тип', logIn: 'Приход', logOut: 'Продажа', logWaste: 'Отход', logsEmpty: 'За этот период записей product_logs нет', allPeriod: 'За весь период', allSuppliers: 'Все поставщики', allModes: 'Все режимы', catalogMode: 'По товарам', withDiscount: 'Со скидкой', dateFrom: 'С', dateTo: 'По', selectDate: 'Выбрать дату', selectDateDone: 'Выбрать', clearDates: 'Сбросить даты', revenue: 'Выручка', receipts: 'Чеки', averageReceipt: 'Средний чек', discountsTotal: 'Скидки', supplierDue: 'Расчёт поставщику', supplierDueHint: 'Себес × изначальный вес (без «продаётся вместе»)', expensesTotal: 'Расходы', wastesTotal: 'Отходы', profit: 'Прибыль', profitFormulaTitle: 'Как считается прибыль', profitFormulaHint: 'Нажмите на цифры сверху — исключить или вернуть статью в расчёт', profitPartOn: 'В расчёте · нажмите, чтобы отключить', profitPartOff: 'Отключено · нажмите, чтобы включить', refunded: 'Возвращён', refund: 'Возврат', refundReason: 'Причина возврата', refundReasonRequired: 'Укажите причину возврата', refundedMessage: 'Чек возвращён', print: 'Печать', close: 'Закрыть', openShift: 'Открыть смену', closeShift: 'Закрыть смену', openingCash: 'Стартовая наличность в кассе', actualCash: 'Фактическая наличность в кассе',
    },
    analytics: {
      title: 'Аналитика', subtitle: 'Выручка, прибыль и точки роста по продажам', overview: 'Обзор', week: 'Неделя', year: 'Год', loading: 'Загрузка аналитики...', todayRevenue: 'Сегодня · выручка', todayReceipts: 'Сегодня · чеки', days30Profit: '30 дней · прибыль', averageReceipt: 'Средний чек', vsYesterday: 'к вчера', margin: 'маржа {value}%', receiptsForDays: '{count} чеков за 30 дней', bestDay: 'Лучший день', salesPeak: 'Пик продаж', around: 'около {time} —', salesHit: 'Хит продаж', units: 'шт', weekToWeek: 'Неделя к неделе', revenue: 'выручки', revenue14Days: 'Выручка за 14 дней', revenueForDays: '{amount} за 30 дней', paymentTypes: 'Типы оплаты', days30: '30 дней', noPayments: 'Пока нет оплат', topProducts: 'Топ-10 товаров', byQuantity: 'По количеству', byRevenue: 'По выручке', soldShort: 'прод.', profit: 'прибыль', noSalesPeriod: 'Нет продаж за период', hourlyActivity: 'Активность по часам', cashierRevenue: 'Выручка по кассирам', today: 'сегодня', receiptsToday: '{count} чек(а)', todayZero: 'сегодня — 0', lowStock: 'Низкий остаток', units5: '≤ 5 единиц', ordersWeek: 'Заказов за неделю', ordersYear: 'Заказов за год', profitLabel: 'Прибыль', sold: 'Продано: {count}', revenueLabel: 'Выручка: {amount}', profitLabelValue: 'Прибыль: {amount}', noWeekData: 'Нет данных за эту неделю', noYearData: 'Нет данных за этот год', total: 'Итого', receipts: 'Чеки', receiptTooltip: '{value} чек.',
    },
    bonuses: {
      title: 'Бонусы', subtitle: 'Клиенты и накопленные бонусы', searchPlaceholder: 'ФИО, телефон или № карты', accrualRate: 'Процент начисления', accrualText: 'При оплате клиенту начисляется {value}% от суммы чека', percent: 'Процент, %', saving: 'Сохранение...', save: 'Сохранить', clients: 'Клиентов', totalBonuses: 'Всего бонусов', now: 'Сейчас', loading: 'Загрузка...', unnamed: 'Без имени', card: 'карта', bonus: 'Бонус', nothingFound: 'Ничего не найдено', noClients: 'Бонус-клиентов пока нет', tryAnother: 'Попробуйте другой запрос', clientsAppear: 'Клиенты появятся после начисления бонуса на кассе', percentRange: 'Укажите процент от 0 до 100', percentSaved: 'Процент сохранён',
      mode: 'Тип бонуса', modePercent: 'Процент от чека', modeNPurchase: 'Каждая N-я покупка', nPurchaseTitle: 'Бонус за N-ю покупку', nPurchaseText: 'После каждой {count}-й покупки клиент получает {value} ₸ бонусов', purchasesCount: 'Количество покупок, N', rewardAmount: 'Сумма бонуса, ₸', nPurchaseRange: 'Укажите количество покупок и сумму бонуса', settingsSaved: 'Настройки бонусов сохранены',
    },
    loans: {
      title: 'Займы', subtitle: 'Долги клиентов с кассы · возврат и контроль просрочки', searchPlaceholder: 'Имя, телефон, сумма...', open: 'Открыт', partial: 'Частично погашен', overdue: 'Просрочен', paid: 'Погашен', cancelled: 'Отменён', all: 'Все', openPlural: 'Открытые', overduePlural: 'Просроченные', paidPlural: 'Погашенные', cancelledPlural: 'Отменённые', partialPlural: 'Частичные', unnamed: 'Без имени', amount: 'Сумма', paidAmount: 'Погашено', remainingAmount: 'Остаток', dueDate: 'Вернуть до', receipt: 'Чек', created: 'Создан', pay: 'Погасить', cancelLoan: 'Отменить займ', history: 'История', nothingFound: 'Ничего не найдено', noLoans: 'Займов пока нет', emptyText: 'Добавьте займ вручную или оформите оплату «Қарыз» на кассе', add: 'Добавить займ', addTitle: 'Оформление долга', addText: 'Долг сразу попадёт в список — без чека с кассы', addSave: 'Сохранить', debtorName: 'Имя должника', debtorNamePlaceholder: 'Как зовут клиента', debtorPhone: 'Телефон', whatsappPhone: 'Номер WhatsApp', debtorPhonePlaceholder: '8 (XXX) XXX-XX-XX', extraPhone: 'Доп. номер', addPhone: 'Добавить номер', removePhone: 'Удалить номер', openWhatsapp: 'Открыть в WhatsApp', extraPhoneInvalid: 'Доп. номер должен содержать 11 цифр', note: 'Заметка', notePlaceholder: 'Дополнительная информация (необязательно)', returnDate: 'Дата возврата', selectDate: 'Выбрать дату', selectDateDone: 'Выбрать', totalDebt: 'Итого к долгу', returnBy: 'Вернуть до', nameRequired: 'Укажите имя', phoneRequired: 'Укажите номер WhatsApp (11 цифр)', amountRequired: 'Укажите сумму долга', dueDateRequired: 'Укажите дату возврата', createdMessage: 'Займ добавлен', payTitle: 'Погашение долга', payText: 'Для «{name}» можно погасить частично или полностью. Остаток: {amount}.', repaymentAmount: 'Сумма погашения', repaymentAmountRequired: 'Укажите сумму погашения', repaymentAmountTooHigh: 'Сумма погашения не может быть больше остатка долга', partialRepaid: 'Частичное погашение сохранено', payPartial: 'Погасить частично', payFull: 'Погасить полностью', payPartialHint: 'Долг будет погашен частично, остаток сохранится', payFullHint: 'Долг будет закрыт полностью', payAmountHint: 'Введите любую сумму не больше остатка', payFullPreset: 'Всё', afterPayRemaining: 'После оплаты останется: {amount}', historyAmount: 'Сумма: {amount}', dateFrom: 'С', dateTo: 'По', clearDates: 'Сбросить даты', cancel: 'Отмена', cancelTitle: 'Отменить займ?', cancelText: 'Запись не удалится — она останется в истории со статусом «Отменён».', cancelReason: 'Причина отмены', cancelReasonPlaceholder: 'Например: чек оформлен ошибочно', cancelReasonRequired: 'Укажите причину отмены', cancelledAt: 'Отменён', cancelledMessage: 'Займ отменён', historyTitle: 'История займа', historyEmpty: 'Действий пока нет', actionCreated: 'Займ создан', actionPaid: 'Долг погашен', actionRepayment: 'Частичное погашение', actionCancelled: 'Займ отменён', repaid: 'Долг погашен',
    },
  },
}
